import { Box } from '@mui/material';
import CardWrapper from '../wrapper/card';
import { editDealThunk } from '../../redux/thunks/deal';
import EditStepOne from './edit_step_1';
import EditStepTwo from './edit_step_2';
import { settingEditClientFlag } from '../../redux/slices/client';
import StepperComponent from '../reusable/stepper';
import { UpdateClientDetailsParams } from '../../params/redux/client';
import { updateClientDetailsThunk } from '../../redux/thunks/client';
import { useParams } from 'react-router';
import { useState } from 'react';
import { AppDispatch, RootState } from '../../redux/store';
import { Bounce, toast } from 'react-toastify';
import { DealEditParams, DealEditStepOneParams, DealEditStepTwoParams } from '../../params/pipeline';
import { setFirstStepDetailsOfDeal, setInitialDealStepValues, setSecondStepDetailsOfDeal } from '../../redux/slices/deal';
import { useDispatch, useSelector } from 'react-redux';

const EditDeal = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams();
    const [activeStep, setActiveStep] = useState(0);
    const [editValues, setEditValues] = useState<DealEditStepOneParams | undefined>();
    const { flags } = useSelector((state: RootState) => state.client);

    const handleStepOne = (values: DealEditStepOneParams) => {
        dispatch(setFirstStepDetailsOfDeal(values));
        setEditValues(values);
        setActiveStep(activeStep + 1);
    };
    const handleStepTwo = async (values: DealEditStepTwoParams) => {
        dispatch(setSecondStepDetailsOfDeal(values));
        if (!editValues) {
            toast.error('Edit values from step one are missing', {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                theme: 'dark',
                transition: Bounce
            });
            return;
        }
        try {
            if (flags.isEditClient && location.pathname.includes(`/app/client/${id}/dashboard`)) {
                const data: UpdateClientDetailsParams = {
                    client_id: parseInt(id as string, 10),
                    client_name: editValues.deal_name,
                    client_email: editValues.deal_email,
                    client_address: editValues.deal_address,
                    city: editValues.deal_city,
                    state: editValues.deal_state,
                    zip: editValues.deal_zip,
                    client_contact: editValues.deal_phone,
                    client_website: values.deal_website,
                    client_facebook: values.deal_facebook,
                    client_twitter: values.deal_twitter,
                    client_linkedin: values.deal_linkedin,
                    client_instagram: values.deal_instagram,
                    client_mobile_friendly: values.deal_mobile_friendly,
                    client_ssl: values.deal_ssl,
                    client_wordpress: values.deal_wordpress,
                    client_shopify: values.deal_shopify,
                    client_facebook_pixel: values.deal_facebook_pixel,
                    client_business_type: values.deal_business_type,
                    client_with_analytics: values.deal_with_analytics,
                    client_google_analytics: values.deal_google_analytics,
                    client_seo_schema: values.deal_seo_schema,
                    client_yelp: values.deal_yelp,
                    client_google_remaketing: values.deal_google_remaketing
                };
                await dispatch(updateClientDetailsThunk(data)).unwrap();
            } else {
                const data: DealEditParams = { ...editValues, ...values };
                await dispatch(editDealThunk(data)).unwrap();
            }
            dispatch(settingEditClientFlag(false));
            dispatch(setInitialDealStepValues());
        } catch (e) {
            // Catch errors
        }
    };
    return (
        <Box p={1} minHeight="80vh" mb="60px" overflow="auto">
            <CardWrapper>
                <Box display="flex" alignItems="center" justifyContent="center" mb={2}>
                    <StepperComponent
                        steps={[
                            '1',
                            '2'
                        ]}
                        activeStep={activeStep}
                    />
                </Box>
                {activeStep === 0 && <EditStepOne setActiveStep={handleStepOne} />}
                {activeStep === 1 && <EditStepTwo setActiveStep={handleStepTwo} cancelHandler={() => setActiveStep(activeStep - 1)} />}
            </CardWrapper>
        </Box>);
};

export default EditDeal;